<template>
  <div class="visa-common-dialog">
    <el-dialog
      :visible.sync="visible"
      :size="size"
      :custom-class="widthClass"
      :title="title"
      :close-on-click-modal="closeOnClickModal"
      top="40%"
      v-bind="$attrs"
      @close="closeModal">
      <slot></slot>
      <div class="common-dialog-footer" slot="footer" v-if="showFooter">
        <slot name="footer"></slot>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'common-dialog',
  components: {
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: true,
    },
    size: {
      type: String,
      default: 'tiny',
    },
    widthClass: {
      type: String,
    },
    title: {
      type: String,
      default: '',
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
  },
  data() {
    return {
      visible: this.show,
    };
  },
  watch: {
    visible(newValue) {
      this.$emit('update:show', newValue);
    },
    show(val) {
      this.visible = val;
    },
  },
  methods: {
    // 关闭对话框回调
    closeModal() {
      this.visible = false;
    },
  },
};
</script>

<style lang="less">
@import "../../../../assets/less/variable";

.visa-common-dialog{
  .el-dialog{
    top: 40%;
    left: 50%;
    transform: translate(-50%, -40%);
    .el-dialog__header{
      padding: 0 24px;
      height: 60px;
      display: flex;
      align-items: center;
      position: relative;
      border-bottom: 1px solid #E9EEF2;
      .el-dialog__title{
        font-size: 18px;
        color: #2F333D;
        font-weight: 600;
      }
      .el-dialog__headerbtn{
        position: absolute;
        right: 24px;
        top: 50%;
        transform: translateY(-50%);
        color: #91999F;
        &:hover{
          color: #599FFF;
        }
      }
    }
    .el-dialog__body{
      padding: 0;
      color: #2F333D;
      font-size: 16px;
      line-height: 22px;
    }

    .el-dialog__footer{
      padding: 0;
      .common-dialog-footer{
        border-top: 1px solid #E9EEF2;
        padding: 16px 24px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 0;
        .s-btn{
          min-width: 98px;
          &+.s-btn{
            margin-left: 16px;
          }
        }
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/modals/common-dialog/common-dialog.vue